import { ticketing } from './ticketing'

// Organiser self-serve event management (/ticketing/organizer/events).
// Every response is the API envelope { code, msg, data } — callers read `.data`.
export default {
    createEvent(data = {}) {
        return ticketing.post('/organizer/events', data)
    },
    // params: { tab: 'draft'|'review'|'live'|'archive', sort: 'newest'|'oldest_submitted', page, pageSize }
    listEvents(params) {
        return ticketing.get('/organizer/events', { params })
    },
    getEvent(id) {
        return ticketing.get(`/organizer/events/${id}`)
    },
    // Partial Basics update — send only the fields that changed.
    updateEvent(id, data) {
        return ticketing.patch(`/organizer/events/${id}`, data)
    },
    deleteEvent(id) {
        return ticketing.delete(`/organizer/events/${id}`)
    },
    submitEvent(id) {
        return ticketing.post(`/organizer/events/${id}/submit`)
    },
    withdrawEvent(id) {
        return ticketing.post(`/organizer/events/${id}/withdraw`)
    },
    getEventStats(id) {
        return ticketing.get(`/organizer/events/${id}/stats`)
    },
    // live → ended: sales close now, check-in keeps working
    endEvent(id) {
        return ticketing.post(`/organizer/events/${id}/end`)
    },
    // live only: { description?, quantityTotal? (increase only), nftImages? }
    patchLiveTier(id, tierId, data) {
        return ticketing.patch(`/organizer/events/${id}/tiers/${tierId}`, data)
    },
    // approved → live; the contract deploys in the background — poll getEvent for deployStatus
    launchEvent(id) {
        return ticketing.post(`/organizer/events/${id}/launch`)
    },
    // Full ordered list of ticket categories; tiers without an id are created.
    replaceTiers(id, tiers) {
        return ticketing.put(`/organizer/events/${id}/tiers`, { tiers })
    },

    // The organiser's Stripe Connect account (shared across all their events)
    getStripeStatus() {
        return ticketing.get('/organizer/stripe')
    },
    startStripeOnboarding(eventId) {
        return ticketing.post('/organizer/stripe/onboard', { eventId })
    },

    // Ticket verification links (scanner access per gate)
    listVerifierLinks(eventId) {
        return ticketing.get(`/events/${eventId}/verifier-tokens`)
    },
    // data: { label, type: 'entry' | 'exit' | 'both' }
    createVerifierLink(eventId, data) {
        return ticketing.post(`/events/${eventId}/verifier-tokens`, data)
    },
    revokeVerifierLink(eventId, tokenId) {
        return ticketing.delete(`/events/${eventId}/verifier-tokens/${tokenId}`)
    },
    // Raw CSV (no envelope) — resolves to a Blob. baseUrl makes the CSV links point at this site.
    exportVerifierLinks(eventId) {
        return ticketing.get(`/events/${eventId}/verifier-tokens/export`, { responseType: 'blob', params: { baseUrl: window.location.origin } })
    },
}
